var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0359 5.0894C16.0901 4.25446 14.667 4.25424 13.7225 5.08956L4.33339 13.3956C3.91203 13.7681 3.87181 14.4118 4.2448 14.833C4.61688 15.2547 5.26329 15.2934 5.6827 14.9212L6.38204 14.3026V22.9351C6.38204 24.3761 7.55473 25.5487 8.99638 25.5487H21.7614C23.2031 25.5487 24.3758 24.3761 24.3758 22.9351V14.3026L25.0755 14.9215C25.2685 15.0929 25.5104 15.1772 25.75 15.1772C26.0303 15.1772 26.312 15.0614 26.5131 14.8329C26.886 14.4117 26.8457 13.7681 26.4244 13.3956L17.0359 5.0894ZM15.073 6.61537C15.2465 6.46173 15.5101 6.4603 15.6865 6.61555L22.3385 12.5006V22.9358C22.3385 23.2532 22.0795 23.5122 21.7614 23.5122H19.5886V19.6303C19.5886 18.2515 18.4671 17.13 17.0883 17.13H13.6695C12.2907 17.13 11.1692 18.2515 11.1692 19.6303V23.5122H8.99638C8.6779 23.5122 8.41927 23.2528 8.41927 22.9358V12.5006L15.073 6.61537ZM13.2064 19.6303C13.2064 19.3748 13.414 19.1673 13.6695 19.1673H17.0883C17.3439 19.1673 17.5514 19.3748 17.5514 19.6303V23.5122H13.2064V19.6303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomesvg);
export default __webpack_public_path__ + "static/media/homesvg.66fc1fcf5b1315c14f4196eac982b289.svg";
export { ForwardRef as ReactComponent };